import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  isSncrAuthPopup,
  subscribeSncrAuthUpdated,
} from "../helpers/authPopup";
import {
  clearLastAuthResult,
  getLastAuthResult,
} from "../helpers/storage";
import {
  isSncrAuthenticated,
  loginWithGovBr,
  processSncrCallback,
} from "../services/sncrAuth";

const CONNECTED_POLL_MS = 5_000;

export function useSncrGovBrLogin() {
  const [isConnected, setIsConnected] = useState(() => isSncrAuthenticated());

  const refreshConnected = useCallback(() => {
    setIsConnected(isSncrAuthenticated());
  }, []);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const ok = await processSncrCallback();
        if (cancelled) return;

        // No popup o toast e o token ficam na aba que abriu o login.
        if (isSncrAuthPopup()) return;

        const last = getLastAuthResult();
        if (ok || last === "success") {
          toast.success("Conectado ao SNCR com sucesso.");
          clearLastAuthResult();
          refreshConnected();
          return;
        }

        if (last === "error") {
          toast.error(
            "Não foi possível conectar ao SNCR. O session_id expira em ~30s e é de uso único.",
          );
          clearLastAuthResult();
          refreshConnected();
        }
      } catch {
        if (cancelled || isSncrAuthPopup()) return;
        toast.error(
          "Não foi possível conectar ao SNCR. O session_id expira em ~30s e é de uso único.",
        );
        clearLastAuthResult();
        refreshConnected();
      }
    })();

    const intervalId = window.setInterval(refreshConnected, CONNECTED_POLL_MS);
    const unsubscribePopup = subscribeSncrAuthUpdated(refreshConnected);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      unsubscribePopup();
    };
  }, [refreshConnected]);

  return {
    loginWithGovBr,
    isConnected,
  };
}
